import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import { customersSlice } from "../app/modules/ECommerce/_redux/customers/customersSlice";
import { collectionsSlice } from "../app/modules/ECommerce/_redux/collections/collectionsSlice";
import { categorySlice } from "../app/modules/ECommerce/_redux/categoriesAction/collectionsSlice";

import { productSlice } from "../app/modules/ECommerce/_redux/initialNFTofferings/collectionsSlice";
import { reportsSlice } from "../app/modules/ECommerce/_redux/reports/reportsSlice";
import { remarksSlice } from "../app/modules/ECommerce/_redux/remarks/remarksSlice";
import { specificationsSlice } from "../app/modules/ECommerce/_redux/specifications/specificationsSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  customers: customersSlice.reducer,
  collections: collectionsSlice.reducer,
  categories: categorySlice.reducer,
  products: productSlice.reducer,
  reports: reportsSlice.reducer,
  remarks: remarksSlice.reducer,
  specifications: specificationsSlice.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
